<template>
	<div class="d-inline-block justify-content-center">
		<div class="d-inline-block mx-1" v-for="(item, index) in textStyles.types" :key="index">
			<TheColorPicker :options="item.options[0]" :selectedOptions="textStyles.selectedOptions[index].options" v-if="item.visible && item.type != null && item.type=='color'" @updateColorEvent="(color)=>updateColor(index, color)"></TheColorPicker>

			<SelectButton v-model="textStyles.selectedOptions[index].options" :options="item.options" aria-labelledby="custom" :multiple="item.multiSelect" @change="updateStyle" v-else-if="item.visible" >
				<template #option="slotProps">
					<span class="material-symbols-outlined">{{ slotProps.option.icon }}</span>
				</template>
			</SelectButton>
		</div>
	</div>
</template>

<script lang="ts">
	import {defineComponent} from "vue";
	import TheColorPicker from "@/components/styles/TheColorPicker.vue";
	
	export default defineComponent({
		emits: ['update-style-event'],
		components: {TheColorPicker},
		props: {
			styles:{
				type: Object,
				required: true,
			}
		},
		computed:{
			textStyles(){
				return this.styles;
			}
		},
		methods: {
			updateStyle() {
				this.$emit('update-style-event', this.textStyles);
			},
			updateColor(index:any, colorCode: any) {
				this.textStyles.selectedOptions[index].options = {...this.textStyles.types[index].options[0]};
				this.textStyles.selectedOptions[index].options.value = colorCode;
				this.updateStyle();
			},
		}
	})
</script>